<template>
  <div class="sign u-overlay u-row u-center u-middle u-overflow-y-scroll u-pad-y-md">
    <div class="login-form u-center u-grey-light u-relative">
      <div class="login-form__bg u-middle u-row u-bg-grey u-w8of12 u-w10of12--md u-w11of12--sm">
        <div class="u-w6of12 u-w12of12--sm u-pad-t-md--sm">
          <div class="u-row u-middle u-center">
            <img src="/images/logo--full.png" class="u-w8of12">
          </div>
        </div>
        <div class="u-w6of12 u-w12of12--sm">
          <div class="u-row u-middle u-pad-lg u-pad-md--sm">
            <div class="t-h3 u-marg-b-md u-center u-full-width">
              {{ $t('login.reset') }}
            </div>
            <div class="u-left">
              <template v-if="!isSend">
                <div>
                  <label for="firstName">{{$t('login.email')}}</label>
                  <input
                    v-model="mail"
                    type="email"
                    id="email"
                    class="t-input u-full-width"
                  />
                </div>
                <div class="u-marg-t-md">
                  <app-button @click="onSend">
                    {{ $t('login.send') }}
                  </app-button>
                </div>
                <div class="u-marg-t-md">
                  <app-button @click="toSignin" :hasGradientBorder="true" class="u-cursor-pointer">
                    {{ $t('login.backToLogin') }}
                  </app-button>
                </div>
              </template>
              <template v-else>
                <div>
                  {{ $t('login.resetConfirm') }}
                </div>

                <app-button @click="toLogin" class="u-inline-block u-marg-t-md u-cursor-pointer">
                  {{ $t('login.goToSbs') }}
                </app-button>
              </template>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div v-show="!$device.isTablet" @click="$router.push($local('create'))" class="t-link change-page t-text t-text--small u-grey-light">
      {{$t('login.alreadyCreate')}}
    </div>
  </div>
</template>


<script>
import { auth } from '@/utils/Auth'

export default {
  data () {
    return {
      mail: '',
      isSend: false
    }
  },

  methods: {
    onSend () {
      this.$ga.send('Password reset', 'Click', 'Send button')
      auth.resetPassword(this.mail).then(() => {
        this.isSend = true
      })
    },
    toSignin () {
      this.$ga.send('Password reset', 'Click', 'Back to sign in button')
      this.$router.push(this.$local('signin'))
    },
    toLogin () {
      this.$ga.send('Password reset', 'Click', 'Back to sign in button')
      this.$router.push(this.$local('login'))
    }
  }
}
</script>

<style lang="stylus" scoped>
@import '~@/styles/settings/variables'

.sign
  &:before
    position fixed
    
.change-page
  position absolute
  top $spacings.md
  right $spacings.md

</style>
